export default __webpack_public_path__ + "media/zurb/img/legacy/reel/instructions-5-47f305e4cfb2e9a4466deadae6f0704c.png";